export default "skymp5-front/dbcde35d197c8a29721b34483c96331b.png";